// extracted by mini-css-extract-plugin
export default {"text-body-1":"LandingBody_text-body-1__ZCbgn","text-body-3":"LandingBody_text-body-3__ys5Uh","landingBody":"LandingBody_landingBody__rYqVn","upDown":"LandingBody_upDown__7aprL"};